/*
  VF: product page behaviour (see sections/vf_product-details.liquid).

  1. Phone buy bar. Fixed to the bottom while the real Add to Cart is off screen. Its button clicks the real
     one, so the variant, quantity and vehicle note all apply and the theme's own cart handling runs.
  2. Vehicle note. When the Convermax fitment check confirms a vehicle, copy it into the "Your vehicle" order
     note so the shopper does not type it twice. Never overwrites something the shopper typed.
*/
(function () {
  var info = document.querySelector('.product-information');
  if (!info) return;

  function realButton() {
    return info.querySelector('add-to-cart-component button, button[name="add"]');
  }

  /* 1. Phone buy bar */
  var bar = document.querySelector('[data-vf-pdb]');
  var barButton = bar && bar.querySelector('[data-vf-pdb-btn]');
  var barPrice = bar && bar.querySelector('[data-vf-pdb-price]');
  var barLabel = barButton ? barButton.textContent : '';

  function syncBar() {
    var button = realButton();
    if (!button || !barButton) return;
    // The real button also holds a hidden "Added" label, so its text is not copied. Only the sold-out state is.
    barButton.disabled = button.disabled;
    barButton.textContent = button.disabled ? 'Sold out' : barLabel;
    var price = info.querySelector('product-price .price, .price');
    if (price && barPrice) barPrice.textContent = (price.textContent || '').replace(/\s+/g, ' ').trim();
  }

  if (bar && barButton && 'IntersectionObserver' in window) {
    var target = realButton();
    if (target) {
      bar.hidden = false;
      document.documentElement.classList.add('vf-has-buy-bar');

      // The chat bubble lifts clear of the bar by this much (see vf_product-page.css). Measured, because the
      // bar grows with the iPhone home-bar inset.
      var measureBar = function () {
        if (bar.offsetHeight) document.documentElement.style.setProperty('--vf-pdb-h', bar.offsetHeight + 'px');
      };
      measureBar();
      window.addEventListener('resize', measureBar);
      // The bubble's offset lives inside Shopify's shadow root, so the glide has to be added there. Without
      // it the bubble just jumps, which still works.
      var easeChat = function () {
        var chat = document.querySelector('shopify-chat');
        var root = chat && chat.shadowRoot;
        if (!root || !root.adoptedStyleSheets || !('replaceSync' in CSSStyleSheet.prototype)) return false;
        var sheet = new CSSStyleSheet();
        sheet.replaceSync('.activator-nudge{transition:bottom .22s ease}@media (prefers-reduced-motion:reduce){.activator-nudge{transition:none}}');
        root.adoptedStyleSheets = root.adoptedStyleSheets.concat(sheet);
        return true;
      };
      var chatTries = 0;
      var chatTimer = setInterval(function () {
        if (easeChat() || ++chatTries > 20) clearInterval(chatTimer);
      }, 1000);
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        // Only once the shopper has scrolled past the button, not while it is still below the fold on load.
        var past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', past);
        document.documentElement.classList.toggle('vf-buy-bar-visible', past);
      }).observe(target);

      barButton.addEventListener('click', function () {
        var button = realButton();
        if (button && !button.disabled) button.click();
      });

      new MutationObserver(syncBar).observe(info, { childList: true, subtree: true, characterData: true });
      syncBar();
    }
  }

  /* 2. Vehicle note from the fitment check */
  var verify = document.getElementById('cm-verify-fitment');
  if (verify) {
    var lastFilled = '';
    var fillNote = function () {
      var vehicle = verify.querySelector('.cm_verify-fitment_vehicle');
      var note = info.querySelector('.custom-property__input, [name="properties[Customer Vehicle]"]');
      if (!vehicle || !note) return;
      var text = (vehicle.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text || text === lastFilled) return;
      if (note.value && note.value !== lastFilled) return;
      note.value = text;
      lastFilled = text;
      note.dispatchEvent(new Event('input', { bubbles: true }));
    };
    new MutationObserver(fillNote).observe(verify, { childList: true, subtree: true });
    fillNote();
  }
})();
